<template>
  <div>
    <div>
          <b-form-group
            id="input-id-group"
            :label="$t('common.AM')"
            label-for="input-id"
            label-align="left"
            label-cols="3"
            content-cols
            class="col-12"
          >
            <b-form-input
                id="input-id"
                type="text"
                v-model="id"
                disabled
                placeholder=""
            >
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-name-group"
            :label="$t('common.name')"
            label-for="input-name"
            label-align="left"
            label-cols="3"
            content-cols
            class="col-12"
          >
            <b-form-input
                id="input-name"
                type="text"
                v-model="fullName"
                disabled
                placeholder=""
            >
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-type-group"
            :label="$t('common.type')"
            label-for="input-type"
            label-align="left"
            label-cols="3"
            content-cols
            class="col-12"
          >
            <v-select
                name="module"
                :options="memberTypes"
                v-model="orgMember.type"
                :reduce="memberType => memberType.type"
                label="label"
                disabled
                class="bg-white rounded"
            />
          </b-form-group>
    </div>
  </div>
</template>

<script>
// import cardHeader from "../common/cardHeader.vue";
// import achievementService from "@/services/achievement.service";

export default {
  // components: { cardHeader },

  mounted() {
    this.id = this.orgMember.id;
    this.fullName = this.orgMember.fullName;
  },
  data() {
    return {
      id: null,
      fullName: null,
      type: null,
      memberTypes: [
        {type: `LEADER`, label: this.$t(`memberTypeEnums.LEADER`) },
        {type: `ROVER`, label: this.$t(`memberTypeEnums.ROVER`)},
        {type: `SUPPORT`, label: this.$t(`memberTypeEnums.SUPPORT`)},
        {type: `OLD_SCOUT`, label: this.$t(`memberTypeEnums.OLD_SCOUT`)}
      ]
    }
  },
  props: {
    orgMember: Object
  }
};
</script>